// Shim for react-native-reanimated on web.
// Re-exports everything from the real module, plus patches two issues
// caused by @react-navigation/drawer@6.7.2 being incompatible with
// Reanimated 4.x:
//
// 1. isConfigured() returns false in Reanimated 4 (deprecated).
//    DrawerView.tsx uses it to decide legacy vs modern drawer.
//    We override it to return true so the modern drawer is used.
//
// 2. useAnimatedGestureHandler was removed in Reanimated 4.
//    The modern Drawer imports it for swipe gestures, but for
//    drawerType:'permanent' on desktop web, no gestures fire.

export * from '../node_modules/react-native-reanimated/lib/module/index';
export { default } from '../node_modules/react-native-reanimated/lib/module/index';

// Override: Reanimated 4 is configured, the function is just deprecated.
export function isConfigured() {
  return true;
}

// Stub: returns a no-op gesture event handler.
export function useAnimatedGestureHandler() {
  return {};
}
